// Table and Chart Component
export default {
  // Table Header Statistics
  totalRecords: "Total",
  records: "records",
  loading: "Loading...",

  // Table Column Names
  blockchain: "Blockchain",
  address: "Address",
  mainBalance: "Main Balance",
  usdtBalance: "USDT Balance",
  totalAsset: "Total Asset (USDT)",
  remark: "Remark",
  assetBalanceChange: "Asset Balance Change (Last 7 Days)",
  action: "Action",

  // Action Buttons
  delete: "Delete",
  addRemark: "Click to add remark",
  loadMore: "Load more data (20 records per load)",
  collapse: "Collapse",
  downloadDetails: "Download Details",

  // Empty State
  noData: "No data available",

  // Message Notifications
  copySuccess: "Copied successfully!",
  addressNotFound: "Address not found",
  deleteConfirm: "Are you sure you want to delete this address?",
  deleteSuccess: "Deleted successfully!",
  deleteCancelled: "Deletion cancelled",
  lastAddressWarning: "This is the last address and cannot be deleted",
  remarkSuccess: "Remark updated successfully!",

  // Dialog
  tip: "Tip",
  confirm: "Confirm",
  cancel: "Cancel",
  warning: "Warning",

  // Download File Name
  balanceData: "Balance Data",
};
